import { render } from "./Advice.vue?vue&type=template&id=c097962e&scoped=true"
import script from "./Advice.vue?vue&type=script&lang=js"
export * from "./Advice.vue?vue&type=script&lang=js"

import "./Advice.vue?vue&type=style&index=0&id=c097962e&scoped=true&lang=css"

import exportComponent from "/var/www/ca-quiz.staging.mindoza.net/releases/20240705152708/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c097962e"]])

export default __exports__